module.exports = __webpack_public_path__ + "img/BACKGROUND_ECO_EMP_LG.03e90580.jpg";